import { render, staticRenderFns } from "./dialogView.vue?vue&type=template&id=2fc778ba&scoped=true"
import script from "./dialogView.vue?vue&type=script&lang=js"
export * from "./dialogView.vue?vue&type=script&lang=js"
import style0 from "./dialogView.vue?vue&type=style&index=0&id=2fc778ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc778ba",
  null
  
)

export default component.exports